import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ColorHelpers } from './color-helper';

export class CustomValidators {
  public static validateColor(c: AbstractControl): ValidationErrors {
    if (!ColorHelpers.isValidColor(c.value)) {
      return { error: 'Invalid color' };
    } else {
      return null;
    }
  }

  static minLengthArray(min: number) {
    return (c: AbstractControl): { [key: string]: any } => {
      if (c.value.length >= min) {
        return null;
      }
      return { minLengthArray: min };
    };
  }

  public static conditionalValidator(callback: Function, validators: ValidatorFn[]) : ValidatorFn {

    return (c: AbstractControl) : ValidationErrors | null => {

      let errors: ValidationErrors = {};

      if (callback()){

        for(let v of validators) {

          const newErrors = v(c);

          if (newErrors) {

            for(let k of Object.keys(newErrors)) {

              errors[k] = newErrors[k];
            }
          }
        }
      }
      
      return Object.keys(errors).length > 0 ? errors : null;
    }
  }
}
